import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import useDashboardStore from '../../../store/dashboardStore/useDashboardStore';
import useUserStore from '../../../store/userStore/useUserStore';
import { locator } from '../../../testing/e2e-locator/locator';

const PersonalSection = (): ReactNode => {
  const { t } = useTranslation();
  const {
    computed: { vehicleId },
  } = useDashboardStore();

  const {
    computed: {
      userFirstName,
      userLastName,
      userPhoneNumber,
      userEmailAddress,
    },
  } = useUserStore();

  return (
    <span data-testid={locator.components.personalSection.root}>
      <div className="head">
        <h3 data-testid={locator.components.personalSection.h3}>
          {t('ApplicantReviewPage.personal')}
        </h3>
        <Link
          data-testid={locator.components.personalSection.editLink}
          to={`/applicant/${vehicleId}/edit-personal`}
        >
          {t('ApplicantReviewPage.edit')}
        </Link>
      </div>

      <ul>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.firstName')}</dt>
            <dd data-testid={locator.components.personalSection.firstName}>
              {userFirstName || '-'}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.lastName')}</dt>
            <dd data-testid={locator.components.personalSection.lastName}>
              {userLastName || '-'}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.phone')}</dt>
            <dd data-testid={locator.components.personalSection.phoneNumber}>
              {userPhoneNumber
                ? userPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                : '-'}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('ApplicantReviewPage.email')}</dt>
            <dd data-testid={locator.components.personalSection.email}>
              {userEmailAddress || '-'}
            </dd>
          </dl>
        </li>
      </ul>
    </span>
  );
};

export default PersonalSection;
